import { Button, makeStyles, Typography } from "@material-ui/core";
import { colours, theme } from "../constants/theme";
import downloadActive from "../assets/icons/download-active.svg";
import downloadInactive from "../assets/icons/download-inactive.svg";
import { ButtonPrimary } from "../components-atoms";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

export const AgencyFeeButtonSection = (props: any) => {
  const {
    downloadClicked,
    downloadDisabled,
    selectAllClicked,
    clearAllClicked,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <div className={classes.buttonWrapper}>
        <Button onClick={selectAllClicked} className={classes.selectAll}>
          <Typography
            variant="button"
            component="span"
            style={{
              color: theme.palette.primary.main,
            }}
            onClick={props.onPrintLabelsClicked}>
            Select all
          </Typography>
        </Button>
      </div>
      <div className={classes.buttonWrapper}>
        <Button onClick={clearAllClicked} disabled={downloadDisabled} className={classes.selectAll}>
          <Typography
            variant="button"
            component="span"
            style={{
              color: !downloadDisabled
                ? theme.palette.primary.main
                : theme.palette.text.disabled,
            }}
            onClick={props.onPrintLabelsClicked}>
            Clear all
          </Typography>
        </Button>
      </div>
      <div className={classes.buttonWrapper}>
        <ButtonPrimary
          className={
            downloadDisabled
              ? classes.disabledDownloadButton
              : classes.downloadButton
          }
          disabled={downloadDisabled}>
          <img
            src={downloadDisabled ? downloadInactive : downloadActive}
            className={classes.buttonIcon}
            alt="download icon"
          />

          <Typography
            variant="button"
            component="span"
            style={{
              color: downloadDisabled
                ? theme.palette.text.disabled
                : theme.palette.primary.main,
            }}
            onClick={downloadClicked}>
            Download
          </Typography>
        </ButtonPrimary>
      </div>
    </div>
  );
};
const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    paddingTop: 24,
    paddingRight: 24,
    paddingBottom: 16,
    justifyContent: "flex-end",
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  downloadButton: {
    minWidth: 64,
    height: 36,
    borderRadius: 8,
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingRight: "16px",
    paddingLeft: "12px",
    color: colours.primary
  },
  disabledDownloadButton: {
    minWidth: 64,
    height: 36,
    borderRadius: 8,
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingRight: "16px",
    paddingLeft: "12px",
    backgroundColor: theme.palette.action.disabledBackground,
    color: "#fff",
    ...textButtonHoverAndActive
  },
  buttonWrapper: {
    marginLeft: "8px",
  },
  selectAll: {
    borderRadius: "8px",
    ...textButtonHoverAndActive
  }
});
